import {create} from 'zustand';

interface DatesState {
  startDate: string;
  endDate: string;
  noOfDays: number;
  period: string;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
  setNoOfDays: (noOfDays: number) => void;
  setPeriod: (period: string) => void;
  clearDates: () => void;
}

const useDatesStore = create<DatesState>(set => ({
  startDate: '',
  endDate: '',
  noOfDays: 0,
  period: '',
  setStartDate: startDate => set(state => ({...state, startDate})),

  setEndDate: endDate => set(state => ({...state, endDate})),

  setNoOfDays: noOfDays => set(state => ({...state, noOfDays})),

  setPeriod: period => set(state => ({...state, period})),

  clearDates: () =>
    set(() => ({
      startDate: '',
      endDate: '',
      noOfDays: 0,
      period: '',
    })),
}));

export default useDatesStore;